var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('highcharts',{staticClass:"chart h-100 min-height-300",attrs:{"constructor-type":'chart',"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }